<template>
    <div>
        <div class="mb-4 mt-2">
            <img class="mx-auto w-auto h-25" v-show="isShowIconFood" src="@/assets/order/order-placed.svg" />
            <img class="mx-auto w-auto h-25" v-show="!isShowIconFood" src="@/assets/noti/ic-logo-bk.svg" />
        </div>
        <div class="text-14 font-bold text-a-brown-502314 text-center" v-html="getname(message)">
        </div>
    </div>
</template>
<script>
import Utility from '@/helper/Utility'
export default {
    name: 'NotificationTypeMessage',
    props: {
        message: {
            type: String
        }
    },
    components: {},
    mixins: [],
    emits: [],
    data: function () { return {} },
    computed: {
        isShowIconFood: function () {
            let msg = this?.message ?? ""
            let foodRegex = /^\(food\)/
            if (foodRegex.test(msg)) {
                return true
            }
            return false
        },
    },
    created: function () { },
    mounted: function () { },
    methods: {
        getname: function (massage) {
            let name = massage.replace(/^\(food\)/, '')
            return Utility.newLineToBr(name);
        }
    }
}
</script>
